import { CommonModule } from "@angular/common"
import { NgModule } from "@angular/core"
import { AngularFireModule } from "@angular/fire/compat"
import { AngularFireAuthModule } from "@angular/fire/compat/auth"
import { BrowserAnimationsModule } from "@angular/platform-browser/animations"
import { ExtraOptions, PreloadAllModules, RouterModule } from "@angular/router"
import { FuseModule } from "@fuse"
import { FuseMockApiModule } from "@fuse/lib/mock-api"
import { FuseConfigModule } from "@fuse/services/config"
import { NgxChartsModule } from "@swimlane/ngx-charts"
import { AppComponent } from "app/app.component"
import { appRoutes } from "app/app.routing"
import { appConfig } from "app/core/config/app.config"
import { CoreModule } from "app/core/core.module"
import { LayoutModule } from "app/layout/layout.module"
import { mockApiServices } from "app/mock-api"
import { environment } from "environments/environment"
import { NgApexchartsModule } from "ng-apexcharts"
import { MarkdownModule } from "ngx-markdown"
import { BusinessAccountService } from "./shared/apis/business-account/api/businessAccount.service"
import { ContactService } from "./shared/apis/contact/api/contact.service"
import { DocumentService } from "./shared/apis/document/api/document.service"
import { MeetingService } from "./shared/apis/meeting/api/meeting.service"
import { ProductService } from "./shared/apis/product/api/product.service"
import { ArPresentationService } from "./shared/apis/ar-presentation/api/arPresentation.service"
import { SubscriptionPackageService } from "./shared/apis/subscription/api/subscriptionPackage.service"
import { TenantService } from "./shared/apis/subscription/api/tenant.service"
import { UserService } from "./shared/apis/user/api/user.service"
import { TeamService } from "./shared/apis/user/api/team.service"
import { GroupService } from "./shared/apis/user/api/group.service"
import { FirebaseAuthService } from "./shared/services/firebase-auth/firebase-auth.service"
import { FuseDrawerModule } from "@fuse/components/drawer"
import { SalesPitchService } from "./shared/apis/product/api/salesPitch.service"
import { NgSelectModule } from "@ng-select/ng-select"
import { ThreadService } from "./shared/apis/openai-connector/api/thread.service"
import { MessageService } from "./shared/apis/openai-connector/api/api"

const routerConfig: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: "enabled",
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),

    // Fuse, FuseConfig & FuseMockAPI
    FuseModule,
    FuseConfigModule.forRoot(appConfig),
    FuseMockApiModule.forRoot(mockApiServices),
    FuseDrawerModule,
    // Core module of your application
    CoreModule,

    // Layout module of your application
    LayoutModule,

    // 3rd party modules that require global configuration via forRoot
    // SPEC-webplanner-033 (GAP-WEBPLANNER-046) — activated to render the live
    // Brief markdown (session-brief-content component). Default sanitization
    // (no `sanitize` override) — LLM output is untrusted input.
    MarkdownModule.forRoot({}),

    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    CommonModule,
    NgxChartsModule,
    NgApexchartsModule,
  ],
  providers: [
    BusinessAccountService,
    ContactService,
    DocumentService,
    FirebaseAuthService,
    MeetingService,
    ProductService,
    ArPresentationService,
    SubscriptionPackageService,
    TenantService,
    UserService,
    TeamService,
    GroupService,
    SalesPitchService,
    ThreadService,
    MessageService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
